import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import TranslationProvider from '../../providers/TranslationProvider';
import Icon from '../Icon';
import './NotifyButton.scss';

const NotifyButton = (props) => {
  const {
    active,
    disabled,
    shrink,
    serviceTypeId,
    onReservationSelect,
  } = props;

  const onSelect = (e) => {
    e.stopPropagation();
    onReservationSelect(null, serviceTypeId);
  };

  return (
    <button
      type="button"
      className={cx('NotifyButton', { shrink, active })}
      disabled={disabled}
      onClick={onSelect}
    >
      <Icon name="Bell" />
      {active
        ? <TranslationProvider translationKey="button_remove_notify"><span>Notify On</span></TranslationProvider>
        : <TranslationProvider translationKey="button_place_notify"><span>Notify</span></TranslationProvider>}
    </button>
  );
};

NotifyButton.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  shrink: PropTypes.bool,
  serviceTypeId: PropTypes.number,
  onReservationSelect: PropTypes.func.isRequired,
};

NotifyButton.defaultProps = {
  active: false,
  disabled: false,
  shrink: false,
  serviceTypeId: null,
};

NotifyButton.displayName = 'NotifyButton';
export default NotifyButton;
